<script>
import { mapState } from 'vuex'
import TextField from '@/components/inputs/TextField.vue'
import HintIcon from '@/components/HintIcon.vue'
import api from '@/api/api'
import { CONNECTOR_TYPES } from '@/vars/general'
export default {
    components: { TextField, HintIcon },
    data: () => ({
        validLogin: null,
        valid: false,
        credentials: {
            auth_key: '',
            domain: '',
        },
        loading: false,
    }),
    computed: {
        ...mapState('project', ['currentAddingConnector']),

        btnDisabled() {
            if (!this.credentials.auth_key || !this.credentials.domain) {
                return true
            }
            return false
        },
    },
    methods: {
        async login() {
            this.loading = true

            const projectId = this.$router.currentRoute.params.id
            const connector = await this.$store.dispatch('project/createConnector', {
                projectId,
                domain: this.credentials.domain,
                connectorType: CONNECTOR_TYPES.pbxOnline,
            })
            const { data, error } = await api.connectors.telephonyPbx.login({
                connectorId: connector.connectorId,
                auth_key: this.credentials.auth_key,
                domain: this.credentials.domain,
            })
            const loginValid = !error
            if (loginValid) {
                this.$store.commit('project/setLoggedAddingConnector', connector)
                this.$parent.$emit('login')
                this.$store.commit('project/setConnectorData', {
                    connectorId: connector.connectorId,
                    data: data,
                    domain: this.credentials.domain,
                    auth_key: this.credentials.auth_key,
                });
            }
            this.validLogin = loginValid
            this.loading = false
        },
    },
}
</script>

<template>
    <div class="auth">
        <div class="form-block pa-10">
            <v-row class="mx-0 mb-4" justify="center" align="center">
                <h2>Телефония Pbx Online</h2>
            </v-row>
            <v-form v-model="valid">
                <v-row class="ma-0">
                    <TextField
                        color="mainNew"
                        filled
                        v-model="credentials.auth_key"
                        label="Уникальный API-key вашей АТС (key)"
                        required
                    />
                    <TextField
                        color="mainNew"
                        filled
                        v-model="credentials.domain"
                        label="Уникальный domain вашей АТС (пример: example.onpbx.ru)"
                        required
                    />
                </v-row>
                <p v-if="validLogin === false" class="error--text">Не верные данные</p>
                <v-btn
                    color="mainNew"
                    class="white--text"
                    @click="login"
                    :disabled="btnDisabled"
                    :loading="loading"
                >Войти</v-btn
                >
            </v-form>
        </div>
    </div>
</template>

<style lang="sass" scoped>
.auth
    display: flex
    justify-content: center
.form-block
    border: 1px solid #0000001F
    min-width: 360px
    min-height: 344px
    max-width: 460px
</style>